import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ParadigmaModal from "../../../components/ParadigmaModal/ParadigmaModal.js"
import api from "../../../api";

import { Row, Col, Label, Input, InputGroup, FormFeedback } from 'reactstrap';

import ParadigmaAsyncSeeker from "../../../components/ParadigmaAsyncSeeker/ParadigmaAsyncSeeker.js"
import PermisosListDetail from "../Permisos/PermisosListDetail.js"

var groupLoaded = false;

class Delete extends Component {
    constructor(props) {
        super(props);
        this.state = {
            padre: null,
            permisos_checked: [],
            permisos_disabled: []
        };
    }

    static propTypes = {
        onSubmit: PropTypes.func.isRequired,
        id: PropTypes.func.isRequired,
    }

    ResetForm() {
        this.setState({
            activeTab: 1,
            padre: null,
            permisos_checked: [],
            permisos_disabled: []
        });
        groupLoaded = false;
    }

    setSelects(data) {
        if (data.padre_id) {
            this.setState({
                padre: data.padre_id,
                permisos_checked: data.Permisos
            });
        } else {
            this.setState({
                padre: 0,
                permisos_checked: data.Permisos
            });
        }
    }

    groupChanged(value) {
        this.setState({
            padre: value.pk,
            permisos_disabled: value.permisos,
            permisos_checked: []
        });
    }

    groupLoaded(value) {
        if (value != undefined && !groupLoaded) {
            groupLoaded = true;
            this.setState({
                permisos_disabled: value.permisos
            });
        }
    }

    render() {
        return (
            <ParadigmaModal
                getUrl={api.usuarios.perfiles.delete}
                postUrl={api.usuarios.perfiles.delete}
                onSubmit={() => this.props.onSubmit()}
                id={this.props.id}
                successMessage={"El Perfil de Usuario ha sido eliminado con éxito."}
                missingIdMessage={"Debe seleccionar una fila."}
                title={"Eliminar Perfil de Usuario"}
                buttonTitle={"Eliminar Perfil de Usuario"}
                buttonIcon={"fa fa-trash fa-lg"}

                saveButton={true}
                closeButton={true}
                danger={true}
                buttonClass={"btn-danger"}
                saveButtonLabel={"Eliminar"}
                onGotData={(data) => this.setSelects(data)}
                onClose={() => this.ResetForm()}
            >
                <Row>
                    <Col className="col-2">
                        <Label>Nombre</Label>
                    </Col>
                    <Col className="col-10">
                        <Input disabled={true} type="text" name="nombre"></Input>
                        <FormFeedback className="col-12"></FormFeedback>
                    </Col>
                </Row>
                <Row className="mt-1">
                    <Col className="col-2">
                        <Label>Padre</Label>
                    </Col>
                    <Col className="col-10">
                        <ParadigmaAsyncSeeker disabled={true} onExternalChange={(value) => this.groupLoaded(value)} onChange={(value) => this.groupChanged(value)} fieldName={"padre_id"} url={api.usuarios.grupos.select} value={this.state.padre} />
                    </Col>
                </Row>
                <Row className="mt-1">
                    <Col className="col-12">
                        <Label>Permisos</Label>
                        <PermisosListDetail fieldName={"permisos"} disabledNodes={this.state.permisos_disabled} onChange={(value) => this.setState({ permisos_checked: value })} checked={this.state.permisos_checked} />
                    </Col>
                </Row>
            </ParadigmaModal>
        );
    }
}

export default Delete;



// WEBPACK FOOTER //
// ./src/views/Usuarios/Perfiles/Delete.js